import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { getUserRole } from '../../core/api/endpoints/users/usersApi';

export interface CommonState {
    initialized: boolean;
    activeRole: number;
    appInitializationPending: boolean;
    appInitializationError: string;
}

const initialState: CommonState = {
    initialized: false,
    activeRole: 1,
    appInitializationPending: false,
    appInitializationError: '',
};

const name = 'initialization';

const getUserRoleThunk = createAsyncThunk(`${name}`, async (params, thunkAPI) => {
    try {
        const role = await getUserRole();
        return role.roleId;
    } catch (error) {
        return thunkAPI.rejectWithValue(error);
    }
});

const commonSlice = createSlice({
    name,
    initialState,
    reducers: {},
    extraReducers: builder => {
        builder
            .addCase(getUserRoleThunk.pending, (state, action) => {
                state.appInitializationPending = true;
                state.initialized = false;
                state.appInitializationError = '';
            })
            .addCase(getUserRoleThunk.fulfilled, (state, action) => {
                state.appInitializationError = '';
                state.initialized = true;
                state.activeRole = action.payload;
                state.appInitializationPending = false;
            })
            .addCase(getUserRoleThunk.rejected, (state, action) => {
                state.appInitializationPending = false;
                state.initialized = false;
                state.appInitializationError = action.payload as string;
            });
    },
});

const { reducer } = commonSlice;

export { reducer as commonReducer };
export { getUserRoleThunk as initializeApplicationThunk };
